import React, { useState, useEffect } from 'react';
import { ListGroup } from 'react-bootstrap'; // Assuming you're using React Bootstrap


import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';

const YourComponent = () => {
    const [selectedItem, setSelectedItem] = useState('Director Office'); // Set default selected item

    const [DirectorOfficers, setDirectorOfficers] = useState([
        // Sample data similar to your provided JSON

          // Director Office
        {
            Name: "Mr. Sahad Parammal ",
            Position: "Junior Superintendent",
            Email: "parammal@iittp.ac.in",
            phoneno: "0877 250 3003",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sahad%20photo.jpg",
            MenuName: "Director Office"
        },

        {
            Name: "Mr. Udaiyakumar R",
            Position: "Senior Assistant",
            Email: "udaya@iittp.ac.in",
            phoneno: "0877 250 3005",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/uday.png",
            MenuName: "Director Office"
        },

          // Registrar Office
          {
            Name: "Mrs. Arcot Likhitha ",
            Position: "Junior Assistant",
            Email: "registrar_office@iittp.ac.in / likhitha@iittp.ac.in",
            phoneno: "0877 250 3041",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Arcot_Likhitha_JA.jpg",
            MenuName: "Registrar Office"
        },
         
       
       
        // {
        //     Name: "Ms. Supraja Akkala ",
        //     Position: "Junior Assistant",
        //     phoneno: "",
        //     Email: "",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Supraja.jpg",
        //     MenuName: "Registrar Office"
        // },

       // {
         //   Name: "Mr. Chaman Mehta",
         //   Position: "Deputy Registrar",
         //   phoneno: "0877 250 3507",
         //   Email: "chaman@iittp.ac.in",
         //   Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
         //   MenuName: "General Administration"

       // },
          // Dean's Office
            {
            Name: "Mr. Srinivasulu K V",
            Position: "Junior Superintendent",
            Email: "kvsrinivasulu@iittp.ac.in",
            phoneno: "0877 250 3511",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS.jpg",
            Department: "Office of Dean - Planning & Infrastructure",
            MenuName: "Deans Offices"
           },

          {
            Name: "Mr. Nagapatla Gnanasekhar",
            Position: "Senior Assistant",
            Email: "office_dofa@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/gnanasekhar.jpg",
            Department: "Office of Dean - Faculty Affairs",
            MenuName: "Deans Offices"
            
        },
       // {
       //     Name: "Ms. Addepalli Haritha",
       //     Position: "Junior Assistant",
       //     Email: "haritha17@iittp.ac.in", // No email provided in the HTML
       //     phoneno: "0877 250 3727", // No phone number provided in the HTML
       //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Addepalli_Haritha_JA.jpg",
       //     Department: "Office of Dean - Global Engagement, Alumni and Corporate Relations",
       //     Department: "Computer Science and Engineering",
       //     MenuName: "Deans Offices"
       // },
        //  {
        //     Name: "Mrs. Arcot Likhitha ",
        //     Position: "Junior Assistant",
        //     Email: "likhitha@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Arcot_Likhitha_JA.jpg",
        //     Department: "Office of Dean - Administration & Finance",
        //     MenuName: "Deans Offices"
        // },

         {
            Name: "Mr. Meenash R",
            Position: "Junior Assistant",
            Email: "cdo_office@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3570", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/R_Meenash_JA.png",
            Department: "Office of Dean - Competency Development & Outreach (CDO) ",
            MenuName: "Deans Offices"
            
        },

         // General Administration
       
        {
            Name: "Mr. Harikrishna Reddy",
            Position: "Assistant Registrar (SS)",
            Email: "harikrishna@iittp.ac.in",
            phoneno: "0877 250 3500",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg",
            MenuName: "General Administration"
        },

         {
            Name: "Mr. Pradeep Kumar Dhanwade",
            Position: "Section Officer",
            Email: "pradeepdhanwade@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Pradeep_Kumar_Dhanwade_SO.png",
            MenuName: "General Administration"
        },

         {
            Name: "Mr. Y Vamsi Krishna",
            Position: "Senior Assistant",
            Email: "vamsi@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/vamsi_ja_est.png",
            MenuName: "General Administration"
        },
            
       
         {
            Name: "Mr. Kishore Reddy Lavanuru",
            Position: "Junior Assistant",
            Email: "lavanurukishore@iittp.ac.in",
            phoneno: "0877 250 3700",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Kishore_Reddy_Lavanuru_JA.jpg",
            MenuName: "General Administration"
        },

         
        // {
        //     Name: "Mr. Nagapatla Gnanasekhar",
        //     Position: "Senior Assistant",
        //     Email: "gnan@iittp.ac.in", // No email provided in the HTML
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/gnanasekhar.jpg",
        //     MenuName: "General Administration"
        // },
         
        {
            Name: "Mr. Chakra Varthi Kandregula",
            Position: "Assistant Security Officer",
            Email: "chakravarthi.aso@iittp.ac.in",
            phoneno: "0877 250 3335",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mr%20Chakravarthi%20K.PNG",
            MenuName: "General Administration"
        },

          // Establishment Section
        {
            Name: "Mr. Chaman Mehta",
            Position: "Joint Registrar",
            Email: "chaman@iittp.ac.in",
            phoneno: "0877 250 3507",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
            MenuName: "Establishment"
        },
       
              
        {
            Name: "Ms. Sheela Reddy T",
            Position: "Assistant Registrar (SS)",
            Email: "sheela@iittp.ac.in",
            phoneno: "0877 250 3504",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sheela.jpg",
            MenuName: "Establishment"

        },
        {
            Name: "Mr. Sugali Hareesh Naik",
            Position: "Junior Superintendent",
            Email: "shnaik@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sugali_Hareesh_Naik_JS.png",
            MenuName: "Establishment" // MenuName information is not provided in the HTML
        },

         {
            Name: "Mr. Somanath Moharana",
            Position: "Junior Superintendent",
            Email: "somanath@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Somanath_Moharana_JS.png",
            MenuName: "Establishment" // MenuName information is not provided in the HTML
        },
       
       
        // {
        //     Name: "Mr. Md Omar Abdul Aziz",
        //     Position: "Junior Assistant",
        //     Email: "omarabdul12214@iittp.ac.in",
        //     phoneno: "0877 250 3503",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mohammed_Omar_Abdul_Aziz_JA.png",
        //     MenuName: "Establishment"
        // },

        
        
       
        // {
        //    Name: "Mr. Vijay S",
        //    Position: "Junior Assistant",
        //   Email: "vijaysekar@iittp.ac.in",
        //    phoneno: "0877 250 3503",
        //   Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijay_S_JA.png",
        //   MenuName: "Establishment"
        // },
        
        {
            Name: "Ms. Bandi Nandini",
            Position: "Junior Assistant",
            Email: "bandinandini@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bandi_Nandini_JA.png",
            MenuName: "Establishment" // MenuName information is not provided in the HTML
        },
         {
            Name: "Mr. Amruth A Gowda",
            Position: "Junior Assistant",
            Email: "amruth@iittp.ac.in",
            phoneno: "0877 250 3042",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Amruth_A_Gowda_JA.png",
            MenuName: "Registrar Office"
        },

        {
            Name: "Mr. Kumar Ankit",
            Position: "Junior Assistant",
            Email: "kumarankit@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Kumar_Ankit_JA.JPG",
            MenuName: "Establishment" // MenuName information is not provided in the HTML
        },
       
          // Competency Development & Outreach

          {
            Name: "Mr. R Meenash",
            Position: "Junior Assistant",
            Email: "meenash@iittp.ac.in",
            phoneno: "0877 250 3570",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/R_Meenash_JA.png",
            MenuName: "Competency Development & Outreach"
        },

         // Centre of Excellence

          {
            Name: "Mrs. Chandragiri Aparna",
            Position: "Junior Technician",
            Email: "caparna@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chandragiri_Aparna_JT.png",
            MenuName: "Centre of Excellence"
        },

         // Central Instrumentation Facility

        {
            Name: "Dr. Achintya Jana",
            Position: "Technical Officer",
            Email: "ajana@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Photo_Achintya_Jana.jpg",
            MenuName: "Central Instrumentation Facility"
        },
        {
            Name: "Mr. Kuntla Reddy Sekhar",
            Position: "Junior Technician",
            Email: "krs@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Kuntla_Reddy_Sekhar_JT_CIF.png",
            MenuName: "Central Instrumentation Facility"
        },
       

          // Estate Office
        {
            Name: "Mr. Chaman Mehta",
            Position: "Joint Registrar & Estate Officer",
            Email: "chaman@iittp.ac.in",
            phoneno: "0877 250 3507",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
            MenuName: "Estate Office"
        },
        {
            Name: "Mr. Srinivasulu K V",
            Position: "Junior Superintendent",
            Email: "kvsrinivasulu@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS.jpg",
            MenuName: "Estate Office"
        },
        // {
        //     Name: "Ms. Sheela Reddy T",
        //     Position: "Assistant Registrar (SS)",
        //     Email: "sheela@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sheela.jpg",
        //     MenuName: "Estate Office"

        // },

          // Academic Section

          {
            Name: "Ms. Ruchika",
            Position: "Deputy Registrar",
            Email: "dr_aa@iittp.ac.in / ruchika@iittp.ac.in",
            phoneno: "0877 250 3533",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ruchika_DR.png",
            MenuName: "Academic Affairs"
        },
       
        {
            Name: "Mr. M. Venkat Ramana",
            Position: "Assistant Registrar",
            Email: "ar_admissions@iittp.ac.in / mvramana@iittp.ac.in",
            phoneno: "0877 250 3530",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkat_Ramana_AR.png",
            MenuName: "Academic Affairs"
        },   
       
        {
            Name: "Mrs. Billu Silpa",
            Position: "Section Officer",
            Email: "bsilpa@iittp.ac.in",
            phoneno: "0877 250 3531 ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/billusilpa.png",
            MenuName: "Academic Affairs"
        },
        

        
        {
            Name: "Mr. K Prasad Rao",
            Position: "Junior Superintendent",
            Email: "prasadrao@iittp.ac.in",
            phoneno: "0877 250 3530",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/PRASAD RAO K.jpg",
            MenuName: "Academic Affairs"
        },
       
       
       
       // {
       //     Name: "Mr. Mohammad Ishaq Alikhan",
       //     Position: "Junior Superintendent",
       //     Email: "ishaq@iittp.ac.in",
       //     phoneno: "0877 250 3532",
       //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ishaq_2.jpg",
       //     MenuName: "Academic Affairs"
       // },

         {
            Name: "Mr. Manicharan Chintakrindi",
            Position: "Junior Superintendent",
            Email: "manicharan@iittp.ac.in",
            phoneno: "0877 250 3532",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/manicharan.jpg",
            MenuName: "Academic Affairs"
        },
        {
            Name: "Mrs. Gunturu Haritha",
            Position: "Senior Assistant",
            Email: "haritha@iittp.ac.in",
            phoneno: "0877 250 3530",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/haritha.jpg",
            MenuName: "Academic Affairs"
        },

        {
            Name: "Mr. V Dinesh Kumar",
            Position: "Junior Assistant",
            Email: "vdinesh@iittp.ac.in",
            phoneno: "0877 250 3532",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/dinesh.jpg",
            MenuName: "Academic Affairs"
        },
        
        {
            Name: "Ms. Basila Ali",
            Position: "Junior Assistant",
            Email: "basilaali@iittp.ac.in",
            phoneno: "0877 250 3531",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Basila_Ali_JA.png",
            MenuName: "Academic Affairs"
        },
        
        {
            Name: "Mr. Ramaprasad Yarra",
            Position: "Junior Assistant",
            Email: "ramaprasad@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ramaprasad_Yarra_JA.png",
            MenuName: "Academic Affairs"
        },
        // {
        //     Name: "Mr. A Manikantanaik",
        //     Position: "Junior Assistant",
        //     Email: "manu_012@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/default.png",
        //     MenuName: "Academic Affairs"
        // },
         {
            Name: "Mr. Vaddi Venkata Naresh",
            Position: "Junior Assistant",
            Email: "naresh2756@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/default.png",
            MenuName: "Academic Affairs"
        },
         {
            Name: "Mr. Adeem Yoosuf",
            Position: "Junior Assistant",
            Email: "adeemyou@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Adeem_Yoosuf_JA.png",
            MenuName: "Academic Affairs"
        },

        {
            Name: "Ms. Nivetha Shri S",
            Position: "Junior Assistant",
            Email: "nivethashri@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/default_female.png",
            MenuName: "Academic Affairs"
        },

          // Finance & Accounts Section
        {
            Name: "Mr. Rajan Babu Lankapalli",
            Position: "Deputy Registrar",
            Email: "rajanbabul@iittp.ac.in",
            phoneno: "0877 250 3550",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rajanbabu.png",
            MenuName: "Finance & Accounts"
        },
        {
            Name: "Mr. Arun Kalyan Kuppannagari",
            Position: "Assistant Registrar",
            Email: "akk@iittp.ac.in",
            phoneno: "0877 250 3545",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Arun%20Kuppannagari.jpg",
            MenuName: "Finance & Accounts"
        },
        {
            Name: "Mrs. Sandhya Y",
            Position: "Section Officer",
            Email: "sandhyayellapragada@iittp.ac.in",
            phoneno: "0877 250 3551",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sandhya.jpg",
            MenuName: "Finance & Accounts"
        },
        {
            Name: "Mr. Sivasankara Reddy",
            Position: "Audit Officer",
            Email: "sivasankar@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sivasankara.jpg",
            MenuName: "Finance & Accounts"
        },
         {
            Name: "Mr. Singareddy Anjaneyulu",
            Position: "Junior Superintendent",
            Email: "anji@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/AnjaneyuluS.jpg",
            MenuName: "Finance & Accounts"
        },

        
    
        {
            Name: "Mr. P. Midhun Kumar",
            Position: "Senior Assistant",
            Email: "midhunkumar07@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/midhun.jpg",
            MenuName: "Finance & Accounts"
        },
        
        {
            Name: "Mr. KVS Roshan Kishore",
            Position: "Junior Assistant",
            Email: "roshankishore@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS_Roshan%20Kishore_JA.jpg",
            MenuName: "Finance & Accounts"
        },
       
       
        {
            Name: "Mr. Kasimsetty Sai Ramkrishna",
            Position: "Junior Assistant",
            Email: "ksairamkrishna@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Kamishetty%20sai%20Ram%20krishna_JA.jpg",
            MenuName: "Finance & Accounts"
        },
        {
            Name: "Mr. Ithih Joy",
            Position: "Junior Assistant",
            Email: "ithihjoy3002001@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ithih_Joy_JA.png",
            MenuName: "Finance & Accounts"
        },
        {
            Name: "Mr. Bhajanthri Gnanendra",
            Position: "Junior Assistant",
            Email: "gnanendra.b@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bhajanthri_Gnanendra_JA.png",
            MenuName: "Finance & Accounts"
        },
        // {
         //    Name: "Mr. Pulikanta Manohara Reddy",
          //   Position: "Junior Assistant",
           //  Email: "manoharreddy@iittp.ac.in",
            // phoneno: " ",
            // Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Pulikunta_Manohara_Reddy_JA.png",
            //MenuName: "Finance & Accounts"
       // }, 
         {
            Name: "Mr. Karra Suneel Kumar",
            Position: "Junior Assistant",
            Email: "karrasuneelkumar@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/default.png",
            MenuName: "Finance & Accounts"
        },
        {
            Name: "Mr. Bayapureddi Naresh Babu",
            Position: "Junior Assistant",
            Email: "nareshbabu@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/default.png",
            MenuName: "Finance & Accounts"
        },



          // Purchase Section
        // {
        //     Name: "Mr. Ramesh. R",
        //     Position: "Assistant Registrar",
        //     Email: "rameshr@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ramesh_photo.JPG",
        //     MenuName: "Purchase & Stores"
        // },
        
         {
            Name: "Shri Umesh Kumar Singh",
            Position: "Assistant Registrar - Stores & Purchase",
            phoneno: "0877 250 3535 / 3572",
            Email: "umesh@iittp.ac.in",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/umeshkumarsingh.png",
            MenuName: "Purchase & Stores"
        },
         {
            Name: "Mr. Madhu N",
            Position: <>Assistant Registrar <br /> (<b>On Deputation</b>)</>,
            Email: "madhunair@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/madhun.png",
            MenuName: "Purchase & Stores"

        },
        // {
        //     Name: "Mr. Ravula Chandrashekar",
        //     Position: "Junior Superintendent",
        //     Email: "rchandrashekar@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ravula_Chandrashekar_JS.png",
        //     MenuName: "Purchase & Stores"
        // },

         {
            Name: "Mr. Y. Vijay",
            Position: "Section Officer",
            Email: "vijay@iittp.ac.in",
            phoneno: "0877 250 3572",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/vijay.jpg",
            MenuName: "Purchase & Stores"
        },
       
        {
            Name: "Mr. Sankar Naidu. L",
            Position: "Junior Superintendent",
            Email: "shankar@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/shankarnaidu.jpg",
            MenuName: "Purchase & Stores"
        },
        {
            Name: "Mr. Ajsal EA",
            Position: "Junior Superintendent",
            Email: "ajsal@iittp.ac.in",
            phoneno: "0877 250 3571",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/MR_Ajsal_JAEA_JA.jpg",
            MenuName: "Purchase & Stores",
        },
         {
            Name: "Mr. Abdul Rafi",
            Position: "Senior Assistant",
            Email: "rafi@iittp.ac.in",
            phoneno: "0877 250 3509",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rafi.jpg",
            MenuName: "Purchase & Stores"
        },
          {
            Name: "Mr. Karthikeyan G",
            Position: "Junior Assistant",
            Email: "karthikeyang@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Karthikeyan_G_JA.png",
            MenuName: "Purchase & Stores"
        },
        {
            Name: "Mr. P. Vidyasagar",
            Position: "Junior Assistant",
            Email: "vsp@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vidyasagar.jpg",
            MenuName: "Purchase & Stores"
        },
       
        {
            Name: "Mr. A Mohan Krishna",
            Position: "Junior Assistant",
            Email: "mohankrishna@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mohan_JA.png",
            MenuName: "Registrar Office",
        },        
       
       
         {
            Name: "Mr. Gandluri Veerendra",
            Position: "Junior Assistant",
            Email: "gandluri.veerendra@iittp.ac.in",
            phoneno: "0877 250 3575 ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Gandluri_Veerendra_JA.png",
            MenuName: "Purchase & Stores"
        },
        {
            Name: "Mr. Avva Venkatesh",
            Position: "Junior Assistant",
            Email: "avvavenky5@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkatesh_Avva_JA.png",
            MenuName: "Purchase & Stores"   
        },  
        {
            Name: "Mr. Mohan Vamsi Saibaba Kotapati",
            Position: "Junior Assistant",
            Email: "mohanvamsi@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mohan-Vamsi-Saibaba-K.jpg",
            MenuName: "Purchase & Stores"   
        },  
        //{
        //    Name: "Mr. Lalam Satyanarayana",
        //    Position: "Junior Assistant",
        //    Email: "satyamouni@iittp.ac.in",
        //    phoneno: " ",
        //    Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Lalam_Satyanarayana_JA.png",
        //    MenuName: "Purchase & Stores"
       // },
       // {
       //     Name: "Mr. Ameer Zerwani",
       //     Position: "Junior Assistant",
       //     phoneno: "", // No phone number provided in the HTML
       //     Email: "", // No email provided in the HTML
       //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ameer.jpg",
       //     MenuName: "Purchase & Stores"
       // },
       // {
       //     Name: "Mr. Ajay J",
       //     Position: "Junior Assistant",
       //     phoneno: "", // No phone number provided in the HTML
       //     Email: "", // No email provided in the HTML
       //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mr_Ajay_J_JA.JPG",
       //     MenuName: "Purchase & Stores"
       // },
        
       

          // Hindi Cell

           {
            Name: "Mr. Pradeep Kumar Dhanwade",
            Position: "Section Officer",
            Email: "pradeepdhanwade@iittp.ac.in",
            phoneno: "0877 250 3516",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Pradeep_Kumar_Dhanwade_SO.png",
            MenuName: "Hindi Cell"
        },
        // {
        //     Name: "Shri Umesh Kumar Singh",
        //     Position: "Assistant Registrar Head, Hindi Cell",
        //     phoneno: "0877 250 3535",
        //     Email: "umesh@iittp.ac.in",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/umeshkumarsingh.png",
        //     MenuName: "Hindi Cell"
        // },
        {
            Name: "Smt C. Vijayalakshmi",
            Position: "Hindi Consultant",
            Email: "vijayalakshmi@iittp.ac.in",
            phoneno: "0877 250 3516", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijayalakshmi.jpeg",
            MenuName: "Hindi Cell"
        },
        // {
        //     Name: "Mr. Aman Kumar Pandey",
        //     Position: "Hindi Translator",
        //     Email: "aman.hindi@iittp.ac.in",
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Aman_Kumar_HT.png",
        //     MenuName: "Hindi Cell"
        // },


        // Departments

        // {
        //     Name: "Ms. Pallagani Maneesha",
        //     Position: "Junior Assistant",
        //     phoneno: "", // No phone number provided in the HTML
        //     Email: "", // No email provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Pallagani_Maneesha_JA.jpg",
        //     MenuName: "Departments",
        //     Department: "Chemical Engineering"
        // },
        {
            Name: "Mrs. Maharasi E",
            Position: "Junior Assistant",
            Email: "maharasi@iittp.ac.in",
            phoneno: "0877 250 3051",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/maharasi.png",
            MenuName: "Departments",
            Department: "Chemical Engineering"
        },
        {
            Name: "Mr. Manukonda Syambabu",
            Position: "0877 250 3101",
            Email: "syambabumanukonda4818@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Manukonda_Syambabu_JA.png",
            MenuName: "Departments",
            Department: "Chemistry"
        },

         {
            Name: "Mr. Jella Vasudev",
            Position: "Junior Assistant",
            Email: "vaasudevjella@iittp.ac.in",
            phoneno: "0877 250 3151",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Jella_Vasudev_JA.png",
            MenuName: "Departments",
            Department: "Civil & Environmental Engineering"
            
        },
        {
            Name: "Ms. Addepalli Haritha",
            Position: "Junior Assistant",
            Email: "haritha17@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3201", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Addepalli_Haritha_JA.jpg",
            MenuName: "Departments",
            Department: "computer science and engineering"
        },

       
        
        {
            Name: "Mr. B Vijay Kumar Naik",
            Position: "Junior Assistant",
            Email: "vijaykumarnaik.vk@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijay_Kumar_Naik_JA.png",
            MenuName: "Establishment"
    
        },
         {
            Name: "Mr. S Sunil Kumar Bharadwaj",
            Position: "Junior Assistant",
            Email: "sskbharadwaj@iittp.ac.in",
            phoneno: "0877 250 3251",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sunil_Kumar_Bharadwaj.png",
            MenuName: "Departments",
            Department: "Electrical Engineering"
        },
             
        {
            Name: "Ms. Akalamkam Venkata Krishna Sravanthi",
            Position: "Junior Assistant",
            Email: "sravanthiakalamkam@iittp.ac.in",
            phoneno: "0877 250 3251",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sravanthi_Akalamkam_Venkata_Krishna_JA.png",
            MenuName: "Departments",
            Department: "Electrical Engineering"
        },

        {
            Name: "Ms. M Anitha Krishna Naik",
            Position: "Junior Assistant",
            Email: "anitha2000@iittp.ac.in",
            phoneno: "0877 250 3301",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Anitha_Krishna_Naik_M_JA.png",
            MenuName: "Departments",
            Department: "Humanities and Social Sciences"
        },
        
         {
            Name: "Mr. Srisudharsan S K",
            Position: "Junior Assistant",
            Email: "srisudharsansk@iittp.ac.in",
            phoneno: "0877 250 3351",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Srisudharsan_S_K_JA.png",
            MenuName: "Departments",
            Department: "Mathematics & Statistics"
        },
       {
            Name: "Mr. Bekkesigandla Vamsi Krishna ",
            Position: "Junior Assistant",
            Email: "kvamsi105@iittp.ac.in",
            phoneno: "0877 250  ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bekkesigandla_Vamsi_Krishna_JA.png",
            MenuName: "Departments",
            Department: "Mechanical Engineering"
        },
        
        {
            Name: "Mr. Ganjikunta Balaji Kiran",
            Position: "Junior Assistant",
            Email: "balajikiran@iittp.ac.in",
            phoneno: "0877 250 3451",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ganjikunta_balaji%20kiran_JA.jpg",
             MenuName: "Departments",
            Department: "Physics"
           
        }, 
       

        // Engineering Unit

        {
            Name: "Mr. R S K Chaitanya Kotagiri",
            Position: "Executive Engineer",
            Email: "rskc@iittp.ac.in",
            phoneno: "0877 250 3603",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/KRSK_Chaitanya.png",
            MenuName: "Engineering Unit"
        },
        {
            Name: "Mr. Sadgurumoorthy Narni",
            Position: "Assistant Executive Engineer - Civil",
            Email: "nsm@iittp.ac.in",
            phoneno: "0877 250 3604",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sadgurumoorthy Narni.png",
            MenuName: "Engineering Unit"
        },
        {
            Name: "Mr. P Mallikarjuna Reddy",
            Position: "Assistant Executive Engineer – Electrical",
            Email: "pmreddy@iittp.ac.in",
            phoneno: "0877 250 3606",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/P_Mallikarjuna.png",
            MenuName: "Engineering Unit"
        },

        {
            Name: "Mr. G Venkata Subba Reddy",
            Position: "Horticulture Officer",
            Email: "gvsubbareddy@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/GVSReddy.png",
            MenuName: "Engineering Unit"
        },

        {
            Name: "Mr. Senthamil Selvan",
            Position: "Assistant Engineer - Civil",
            Email: "selvan@iittp.ac.in",
            phoneno: "0877 250 3602",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/tamil-new-photo.jpg",
            MenuName: "Engineering Unit"
        },
        {
            Name: "Mr. Chaitanya Subba Reddy",
            Position: "Assistant Engineer - Electrical",
            Email: "csrt@iittp.ac.in",
            phoneno: "0877 250 3605",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaitanyareddy.jpg",
            MenuName: "Engineering Unit"
        },
  

        {
            Name: "Mr. Nallam Manoj",
            Position: "Junior Engineer - Civil",
            Email: "nmanoj@iittp.ac.in",
            phoneno: "0877 250 3608",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Nallam_Manoj_JE-Civil.png",
            MenuName: "Engineering Unit"
        },

         {
            Name: "Mr. H Sathish",
            Position: "Junior Engineer - Civil",
            Email: "sathishhariharan@iittp.ac.in",
            phoneno: "0877 250 3608",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sathish_H_JE_EU.png",
            MenuName: "Engineering Unit"
        },
        
        {
            Name: "Mr. R Niranjan",
            Position: "Senior Technician - Electrical",
            Email: "niranjan@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/R_Niranjan.png",
            MenuName: "Engineering Unit"
        },
        {
            Name: "Mr. Gattu Aravind",
            Position: "Junior Engineer - Mechanical",
            Email: "gattuaravind@iittp.ac.in",
            phoneno: "0877 250 3607",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Gattu_Aravind_JE.jpg",
            MenuName: "Engineering Unit"
        },

        {
            Name: "Ms. G Sravya",
            Position: "Junior Technician - Electrical",
            Email: "sravyagorapalli@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sravya.jpg",
            MenuName: "Engineering Unit"
        },
        {
            Name: "Mr. G Ravi",
            Position: "Technician - Electrical",
            Email: "ravi@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/G_Ravi.png",
            MenuName: "Engineering Unit"
        },

         {
            Name: "Mr. Karumanchi Prem Kumar",
            Position: "Junior Technician - Civil",
            Email: "premcivil94@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/K-prem-Kumar.jpg",
            MenuName: "Engineering Unit"
        },
              

        // Computer Centre

        {
            Name: "Mr. P Vamshi Seshasayan",
            Position: "Technical Officer",
            Email: "to_systems@iittp.ac.in / vamshi@iittp.ac.in",
            phoneno: "0877 250 3621",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/vamshi.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mrs. R. Aswini",
            Position: "Technical Superintendent",
            Email: "aswinir@iittp.ac.in",
            phoneno: "0877 250 3626",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/aswini_photo.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. T. Senthil",
            Position: "Technical Superintendent",
            Email: "senthil@iittp.ac.in",
            phoneno: "0877 250 3622",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/senthil.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. G Ramesh",
            Position: "Junior Technical Superintendent",
            Email: "ramesh@iittp.ac.in",
            phoneno: "0877 250 3628",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rameshg.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. B.S. Ramkumar",
            Position: "Junior Technical Superintendent",
            Email: "ramkumar@iittp.ac.in",
            phoneno: "0877 250 3627",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramkumar_jts.jpg",
            MenuName: "Computer Centre"
        },
        // {
        //     Name: "Mr. Ajithraj. R. A",
        //     Position: "Junior Technical Superintendent",
        //     Email: "ajithraj@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ajithraj_Jts.jpeg",
        //     MenuName: "Computer Centre"
        // },

        {
            Name: "Mr. Akhil A Chacko",
            Position: "Junior Technical Superintendent",
            Email: "akhil.chacko@iittp.ac.in",
            phoneno: "0877 250 3629",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Akhil_JTS_CC.png",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. Janga Ananda Babu",
            Position: "Junior Technician",
            Email: "anandajanga@iittp.ac.in",
            phoneno: "0877 250 3625",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ananda_Babu_Janga_JT.png",
            MenuName: "Computer Centre"
        },

         {
            Name: "Mr. Deepak Babu",
            Position: "Junior Technician",
            Email: "deepakbabu@iittp.ac.in",
            phoneno: "0877 250 3627",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Deepak_babu_JT_CC.png",
            MenuName: "Computer Centre"
        },

        {
            Name: "Mr. Darnasi Vinay Kumar",
            Position: "Junior Assistant",
            Email: "dvinaykumar1119@iittp.ac.in",
            phoneno: "0877 250 3630",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vinay_Kumar_JA_CC.jpg",
            MenuName: "Computer Centre"
            
        },

       
         

        // Health Care


        {
            Name: "Dr. Venkata Ramarao Kintali MBBS, DNB, FCD, CTCCM",
            Position: "Senior Medical Officer",
            Email: "drkvr@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3771", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramarao.png",
            MenuName: "Health Care"
        },
        {
            Name: "Dr. Sruthi Kodidini  MBBS, MD.OBG",
            Position: "Medical Officer",
            Email: "sruthikodidini@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3772", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sruthi.jpg",
            MenuName: "Health Care"
        },
        {
            Name: "Mrs. Pakala Nagamani",
            Position: "Staff Nurse",
            Email: "nagamani@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3770", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/nagamani.png",
            MenuName: "Health Care"
        },
        {
            Name: "Mr. J Sesha Naidu",
            Position: "Staff Nurse",
            Email: "jsnaidu@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3770", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/seshanaidu.jpg",
            MenuName: "Health Care"
        },

        {
           Name: "Mr. Praveen P",
            Position: "Junior Nursing Officer",
            Email: "praveenp@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3770", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Praveen_P_JNO.png",
            MenuName: "Health Care"
        },
        
        

        // HoME

        {
            Name: "Mr. Harikrishna Reddy",
            Position: "Assistant Registrar (SS)",
            phoneno: "0877 250 3798", // No phone number provided in the HTML
            Email: "harikrishna@iittp.ac.in", // No email provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg",
            MenuName: "HoME Section"
        },
        {
            Name: "Mr. G. Ramoji Rao",
            Position: "Junior Superintendent",
            Email: "ramji@iittp.ac.in",
            phoneno: "3797",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramji.jpg",
            MenuName: "HoME Section"
        },

        // GAC
        // {
        //     Name: "Ms. Aparna Sai Ramesh",
        //     Position: "Assistant Program Administrator",
        //     Email: "aparna15@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Aparna_Sai_Ramesh_IAA.png",
        //     MenuName: "IAA"
        // },
         {
            Name: "Mr. Chaman Mehta",
            Position: "Joint Registrar",
            Email: "chaman@iittp.ac.in",
            phoneno: "0877 250 3507",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
            MenuName: "Global Engagement, Alumni and Corporate Relations"
        },
        {
            Name: "Mr. Amit Kumar Goswami",
            Position: "Junior Superintendent",
            Email: "amitgoswami@iittp.ac.in",
            phoneno: "0877 250 3728",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Amit_G.JPG",
            MenuName: "Global Engagement, Alumni and Corporate Relations"
        },
        {
            Name: "Mr. Vemuru Sree Varun Tej",
            Position: "Junior Assistant",
            Email: "varuntej@iittp.ac.in",
            phoneno: "0877 250 3727",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vemuru_Sree_Varun_Tej_JA.png",
            MenuName: "Global Engagement, Alumni and Corporate Relations"
        
        },
        
        
        // {
        //     Name: "Ms. Addepali Haritha",
        //     Position: "Junior Assistant",
        //    phoneno: "", // No phone number provided in the HTML
        //     Email: "", // No email provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Addepalli_Haritha_JA.jpg",
        //     MenuName: "IAA" // MenuName information is not provided in the HTML
        // },
       
        // Laboratories
        {
            Name: "Mr. Rapolu Mallikarjun",
            Position: "Junior Technical Superintendent",
            Email: "rmallichemical@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/mallikarjun.jpg",
            Department: "Chemical Engineering",
            MenuName: "Laboratories"
        },
       
         {
            Name: "Dr. A K Suresh",
           Position: "Junior Technical Superintendent",
           Email: "aksuresh@iittp.ac.in", // No email provided in the HTML
           phoneno: " ", // No phone number provided in the HTML
           Image: "https://files.iittp.ac.in/images/demo/iit/Staff/A_K_Suresh.jpg",
           Department: "Chemical Engineering",
           MenuName: "Laboratories"
        },
        
       {
            Name: "Mr. V. Ramasubbaiah",
            Position: "Junior Technical Superintendent",
            Email: "ramasubbaiah.v@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ramasubbaiah_JTS_CH.png",
            Department: "Chemical Engineering",
            MenuName: "Laboratories"
        },
       // {
         //   Name: "Mr. Balaram Tandelu",
         //   Position: "Technician",
         //   Email: "tbalaram9@iittp.ac.in", // No email provided in the HTML
         //   phoneno: " ", // No phone number provided in the HTML
         //   Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Balaram.jpg",
         //   Department: "Chemical Engineering",
         //   MenuName: "Laboratories"
        //},
        {
            Name: "Mrs. Konduru Harika",
            Position: "Junior Technician",
            Email: "harika@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Harika_JA.jpg",
            Department: "Chemical Engineering",
            MenuName: "Laboratories"
        },
         {
            Name: "Mrs. Ethamakula Yogitha Sree",
            Position: "Junior Technician",
            Email: "ethamakulayogitha@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ethamakula_Yogitha_Sree_JT_CH.png",
            Department: "Chemical Engineering",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. M. Jagadeesh",
            Position: "Technical Superintendent",
            Email: "jagam@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/jagadesh.jpg",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. Sanyasinaidu Gottapu",
            Position: "Technical Superintendent",
            Email: "naidugottapu@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/naidu.jpg",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Sai Prabhath Upparu Gonabhavi",
            Position: "Junior Technician",
            Email: "saiprabhath@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sai_prabath_upparu_gonabhavi_JT.jpg",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Badavath Rambabu",
            Position: "Junior Technician",
            Email: "rambabujt001@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Badavath_Rambabu_JT.png",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Kattamuri Kumar Raja",
            Position: "Junior Technician",
            Email: "kattamuri80@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Kattamuri_Kumar_Raja_JT.png",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Marrapu Tirupati Naidu",
            Position: "Junior Technician",
            Email: "tirupathinaidu99@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Marrapu_Tirupati_Naidu_JT.png",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
    

      //  {
        //    Name: "Mr. Nagarajan R",
        //    Position: "Junior Technical Superintendent",
        //    Email: "nagarajan@iittp.ac.in", // No email provided in the HTML
        //    phoneno: " ", // No phone number provided in the HTML
        //    Image: "https://files.iittp.ac.in/images/demo/iit/Staff/nagarajan_new.jpeg",
        //    Department: "Computer Science",
        //    MenuName: "Laboratories"
       // },
        {
            Name: "Mr. Gummuluri Sai Raj",
            Position: "Junior Technical Superintendent",
            Email: "sairaj@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Gummuluri_Sai_Raj_JTS.png",
            Department: "Computer Science",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Abijith P M",
            Position: "Technician",
            Email: "abijith@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/abhijit.jpg",
            Department: "Computer Science",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. M. Suneel Kumar",
            Position: "Technical Officer",
            Email: "suneel@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/MSK.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. S Ruthrapathi",
            Position: "Technical Superintendent",
            Email: "ruthrapathis@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ruthrapathy.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. M. Sivanathan",
            Position: "Junior Technical Superintendent",
            Email: "sivanathan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sivanathan.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Priyangan A",
            Position: "Senior Technician",
            Email: "priyangan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Priyangan.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. M. Sunil Kumar",
            Position: "Senior Technician",
            Email: "manugondasunil@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sunilkumar.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Naveen Kumar B M",
            Position: "Junior Technician",
            Email: "naveeniit@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Naveen_Kumar_B_M_JT.png",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Devaravai Sri Anjan",
            Position: "Junior Technician",
            Email: "devaravaisrianjan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Devaravai_Sri_Anjan_JT.png",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        // {
        //     Name: "Mr. Sreekanth Ramachandran",
        //     Position: "Junior Technician - Systems",
        //     Email: "sreekanth@iittp.ac.in", // No email provided in the HTML
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sreekanth_JT_CEE.png",
        //     Department: "Civil",
        //     MenuName: "Laboratories"
        // },  
        {
            Name: "Mr. T Sathish Kumar",
            Position: "Technical Officer",
            Email: "sathishkumart@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3290", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sathish_Ele.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Pujari Dinesh Khanna",
            Position: "Technical Superintendent - Semiconductor Lab",
            Email: "pdkhanna@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3291", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/PUJARIDINESHKHANNA.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Y Suravardhana Reddy",
            Position: "Technical Superintendent - Wireless Communication Lab",
            Email: "suravardhana@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3294", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/suravardhan.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. K N Dwaraka Natha",
            Position: "Junior Technical Superintendent - Electrical Machines & Power Systems lab",
            Email: "knd@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3298 / 3299", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/dwarakanath.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Kollu Homprakash",
            Position: "Junior Technical Superintendent - Electronic Instrumentation Lab",
            Email: "homprakashk@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3293", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Homprakash.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Kumar Bellikatti",
            Position: "Junior Technical Superintendent - VLSI Lab",
            Email: "kbkatti@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3296", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/bellikatti.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        
        {
            Name: "Mr. Vijay Kumar Aakarapu",
            Position: "Junior Technical Superintendent - 5G Lab",
            Email: "vijayaakarapu@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3292", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijay_Kumar_Aakarapu.png",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mrs. A Chaitanya",
            Position: "Junior Technician - Electronics Lab",
            Email: "chaitanya2023@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3295", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaitanya_JT_EE.png",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
         {
            Name: "Mr. Sreekanth Ramachandran",
            Position: "Junior Technical Superintendent",
            Email: "sreekanth@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sreekanth_JT_CEE.png",
            Department: "Humanities and Social Sciences",
            MenuName: "Laboratories"
        },
         {
            Name: "Mr. V Jayaprakash",
            Position: "Junior Technical Superintendent",
            Email: "jayaprakashveeri@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3636", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Jayaprakash_JTS.png",
            Department: "Mathematics and Statistics",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. Babu Raj M",
            Position: "Technical Officer",
            Email: "Baburajm@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Baburaj.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. B. Ramesh Kumar",
            Position: "Technical Superintendent",
            Email: "beesam@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramesh.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Prodduturu Dasthagiri",
            Position: "Technical Superintendent",
            Email: "dgiri@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/dasthagiri.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. S Venkata Narayana",
            Position: "Technical Superintendent",
            Email: "svn@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/narayana.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Sai Chaitanya Pilla",
            Position: "Technical Superintendent",
            Email: "chaitanya@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/chaitanyapilla.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        
        {
            Name: "Mr. Midathana Ramesh",
            Position: "Senior Technician",
            Email: "rameshmech@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/RameshM.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },


       
        {
            Name: "Mr. Keerthi Veera Venkata Satya Sai",
            Position: "Junior Technician",
            Email: "kvvsatyasai@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkata_Satya_Sai.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. Raja V",
            Position: "Junior Technician",
            Email: "vra@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Dr_Raja_JT_ME.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. Voma Uday Kumar",
            Position: "Technical Superintendent",
            Email: "vuk@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/uday.jpg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. Durga Rama Pavan V",
            Position: "Junior Technical Superintendent",
            Email: "pavan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/durgarama.jpeg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. P. Mohanapriya",
            Position: "Technical Superintendent",
            Email: "mohana.physics@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mohanapriya.jpg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        
        {
            Name: "Mr. Satishbabu Thota",
            Position: "Junior Technical Superintendent",
            Email: "tsbabu@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/satish.jpg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Pelluru Bharath Kumar",
            Position: "Junior Technician",
            Email: "pellurubharath@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bharath_JT_PH.png",
            Department: "Physics",
            MenuName: "Laboratories"
        },
         {
            Name: "Mr. Praveen Kumar Panda",
            Position: "Junior Technician",
            Email: "praveenkumarpanda@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Praveen_Kumar_Panda_JT_PH.jpg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. RameshKrishnan A",
            Position: "Technical Superintendent",
            Email: "ark@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3736", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ark.jpg",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. N Hanumanthu Rao Naik",
            Position: "Junior Technical Superintendent",
            Email: "nhraon@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Hanumanthrao.jpg",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        
        {
            Name: "Mr. Parthiban K",
            Position: "Senior Technician",
            Email: "kp@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/parthiban.jpg",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Bodele Shubham Sanjay",
            Position: "Junior Technician",
            Email: "shu.bodele@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bodele_Shubham_Sanjay_JT_WS.png",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Naveen Kumar",
            Position: "Junior Technician",
            Email: "naveenkumar01@iittp.ac.in", // No email provided in the HTML
            phoneno: "", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Naveen_JT_WS.png",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Nagendran C",
            Position: "Junior Technician",
            Email: "nagendran@iittp.ac.in", // No email provided in the HTML
            phoneno: "", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Nagendran_JT_WS.png",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },

        // Library

        {
            Name: "Mr. Prashanta Kumar Behera",
            Position: "Deputy Librarian",
            Email: "pkbehera@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3591", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Prashanta_Kumar_Behera_DL.png",
            MenuName: "Library"
        },

        {
            Name: "Mr. Shameer K K",
            Position: "Assistant Librarian (SS)",
            Email: "shameer@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3593", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Shameer.jpg",
            MenuName: "Library"
        },
        {
            Name: "Dr. Fathima Azra Fazal",
            Position: "Technical Superintendent",
            Email: "azra@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3592", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/azra.jpg",
            MenuName: "Library"
        },
        {
            Name: "Mr. Pramod Kumar Meher",
            Position: "Junior Library Superintendent",
            Email: "pramod@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3592", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Pramod.png",
            MenuName: "Library"
        },
        {
            Name: "Mr. Mahadev Shahaji Mohite",
            Position: "Junior Library Technician",
            Email: "mahadev@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3592", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mahadev.png",
            MenuName: "Library"
        },

        //Recruitment
        {
            Name: "Mr. S. L. Pradeep Valan",
            Position: "Assistant Registrar",
            Email: "slpvalan@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3525", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/valan.jpg",
            MenuName: "Recruitment"
        },
         {
            Name: "Mr. Saligari Akhil Rathna",
            Position: "Junior Superintendent",
            Email: "akhilrathna@iittp.ac.in",
            phoneno: "0877 250 3505",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/akhil.jpg",
            MenuName: "Recruitment"
        },
       
        
        // {
        //     Name: "Mr. Alok Prakash Tripathi",
        //     Position: "Junior Superintendent",
        //     Email: "alok.tripathi@iittp.ac.in", // No email provided in the HTML
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Alok_Prakash_Tripathi_JS.jpg",
        //     MenuName: "Recruitment"
        // },
        {
            Name: "Mr. Nagapatla Gnanasekhar",
            Position: "Senior Assistant",
            Email: "gnan@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3505", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/gnanasekhar.jpg",
            MenuName: "Recruitment"
        },

        // NSS Section

        // {
        //     Name: "Mr. Mahesh Kumar Mulakala",
        //     Position: "NSS Program Officer",
        //     Email: "maheshkumar@iittp.ac.in",
        //     phoneno: "9866454684",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/maheshkumar.jpg",
        //     MenuName: "NSS"
        // },

        //Placement

        {
            Name: "Mr. J. Prabhu Kiran",
            Position: "Placement Officer",
            Email: "placement@iittp.ac.in",
           phoneno: "8985464383 / 9182969286 / 0877-250 3672",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/PrabhuKiran.jpg",
            MenuName: "Placement"
        },

        {
            Name: "Mr. Abhinay Irala",
            Position: "Training and Placement Officer",
            Email: "placement_officer@iittp.ac.in",
            phoneno: "9966830630 / 0877-250 3672",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Abhinay_Irala.PNG",
            MenuName: "Placement"
        },

         //Planning & Infrastructure

          {
            Name: "Shri Umesh Kumar Singh",
            Position: "Assistant Registrar",
            phoneno: "0877 250 3535",
            Email: "umesh@iittp.ac.in",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/umeshkumarsingh.png",
            MenuName: "Planning & Infrastructure"
        },
         {
            Name: "Mr. Srinivasulu K V",
            Position: "Junior Superintendent",
            Email: "kvsrinivasulu@iittp.ac.in",
            phoneno: "0877 250 3511",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS.jpg",
            MenuName: "Planning & Infrastructure"
        },

        //  {
        //     Name: "Ms. Sheela Reddy T",
        //     Position: "Assistant Registrar (SS)",
        //     Email: "sheela@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sheela.jpg",
        //     MenuName: "Planning & Infrastructure"
        // },
        

        // Student Affairs 

        {
            Name: "Mr. Harikrishna Reddy",
            Position: "Assistant Registrar (SS)",
            phoneno: "0877 250 3798", // No phone number provided in the HTML
            Email: "harikrishna@iittp.ac.in", // No email provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg",
            MenuName: "Student Affairs"
        },

        // {
        //     Name: "Mr. M. Venkat Ramana",
        //     Position: "Assistant Registrar",
        //     Email: "ar_sa@iittp.ac.in", // No email provided in the HTML
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkat_Ramana_AR.png",
        //     MenuName: "Student Affairs"
        // },

        //Guest House (Visitors Hostel)

        // {
        //     Name: "Mr. Chaman Mehta",
        //     Position:  <>Deputy Registrar <br /> (<b>On Deputation</b>)</>,
        //     Email: "chaman@iittp.ac.in",
        //     phoneno: "0877 250 3507",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
        //     MenuName: "Guest House (Visitors Hostel)"
        // },
         {
            Name: "Mr. Harikrishna Reddy",
            Position: "Assistant Registrar (SS)",
            phoneno: "0877 250 3500", // No phone number provided in the HTML
            Email: "harikrishna@iittp.ac.in", // No email provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg",
            MenuName: "Guest House (Visitors Hostel)"
        },
         {
            Name: "Mr. Kishore Reddy Lavanuru",
            Position: "Junior Assistant",
            Email: "lavanurukishore@iittp.ac.in",
            phoneno: "0877 250 3700",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Kishore_Reddy_Lavanuru_JA.jpg",
            MenuName: "Guest House (Visitors Hostel)"
        },
        // {
        //     Name: "Shri Umesh Kumar Singh",
        //     Position: "Assistant Registrar",
        //     phoneno: "0877 250 3535",
        //     Email: "umesh@iittp.ac.in",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/umeshkumarsingh.png",
        //     MenuName: "Guest House (Visitors Hostel)"
        // },

        // {
        //     Name: "Mr. Abdul Rafi",
        //     Position: "Senior Assistant",
        //     Email: "rafi@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rafi.jpg",
        //     MenuName: "Guest House (Visitors Hostel)"
        // },

        //Guidance and Counselling Unit

        {
            Name: "Mr. Pranav Raj. P",
            Position: "Student Counsellor",
            Email: "pranav@iittp.ac.in",
            phoneno: "0877 250 3333",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mr_Pranav_Raj.png",
            MenuName: "Guidance & Counselling Unit"
        },

         //Public Relation Office

         {
            Name: "Mr. Chaman Mehta",
            Position: "Joint Registrar & Public Relation Officer",  
            Email: "chaman@iittp.ac.in",
            phoneno: "0877 250 3507",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
            MenuName: "Public Relation Office"
        },
        // {
        //     Name: "Mr. Harikrishna Reddy",
        //     Position: "Assistant Registrar (SS) & Public Relation Officer",
        //     Email: "harikrishna@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg",
        //     MenuName: "Public Relation Office"
        // },
        // {
        //     Name: "Mr. Mahesh Kumar Mulakala",
        //     Position: "Assistant Public Relation Officer",
        //     Email: "maheshkumar@iittp.ac.in",
        //     phoneno: "9866454684",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/maheshkumar.jpg",
        //     MenuName: "Public Relation Office"
        // },

       
        //  Sports

        {
            Name: "Dr. Iyappan. I",
            Position: "Sports Officer",
            Email: "iyappan@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3647", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/iyyapan.png",
            MenuName: "Sports"
        },
        
        {
            Name: "Mr. Sreedhar Reddy T",
            Position: "Physical Training Instructor",
            Email: "tsreedharreddy@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sreedhar_Reddy_PTI.png",
            MenuName: "Sports"
        },
         {
            Name: "Mr. M Pavan",
            Position: "Junior Sports Officer",
            Email: "pavanmotani@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/M_Pavan_JSO.png",
            MenuName: "Sports"
        },

        // CSRC Office

        // {
        //     Name: "Dr K. Thiruppathi",
        //     Position: "Chief Manager",
        //     Email: "kthiruppathi@iittp.ac.in", // No email provided in the HTML
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Thiruppathi.jpg",
        //     Email: "kthiruppathi@iittp.ac.in",
        //     MenuName: "CSRC Office"
        // },
        {
            Name: "Mr. Rajan Babu Lankapalli",
            Position: "Deputy Registrar",
            Email: "rajanbabul@iittp.ac.in",
            phoneno: "0877 250 3550",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rajanbabu.png",
            MenuName: "CSRC Office"
        },
        // {
        //     Name: "Mr. Ramesh. R",
        //     Position: "Assistant Registrar",
        //     Email: "rameshr@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ramesh_photo.JPG",
        //     MenuName: "CSRC Office"
        // },
        
        {
            Name: "Mr. Arun Kalyan Kuppannagari",
            Position: "Assistant Registrar",
            Email: "akk@iittp.ac.in",
            phoneno: "0877 250 3545",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Arun%20Kuppannagari.jpg",
            MenuName: "CSRC Office"
        },
        
         {
            Name: "Shri Umesh Kumar Singh",
            Position: "Assistant Registrar - Stores & Purchase",
            phoneno: "0877 250 3535",
            Email: "umesh@iittp.ac.in",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/umeshkumarsingh.png",
            MenuName: "CSRC Office"
        },
         {
            Name: "Mr. Madhu N",
            Position: <>Assistant Registrar <br /> (<b>On Deputation</b>)</>,
            Email: "madhunair@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/madhun.png",
            MenuName: "CSRC Office"

        },
        {
            Name: "Mr. Y. Vijay",
            Position: "Section Officer",
            Email: "vijay@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/vijay.jpg",
            MenuName: "CSRC Office"
        },

        // {
        //     Name: "Mrs. S Vinodha",
        //     Position: "Project Manager",
        //     Email: "vinodha@iittp.ac.in", // No email provided in the HTML
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vinodha.jpg",
        //     Email: "pm_csrc@iittp.ac.in",
        //     MenuName: "CSRC Office"
        // },

         {
            Name: "Mr. P Reddy Prasad",
            Position: "Junior Superintendent",
            Email: "pulireddyprasad@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/default.png",
            MenuName: "CSRC Office"
        },

        {
            Name: "Mrs. Pubali Mandal",
            Position: "Project Manager - IPR & Innovation",
            Email: "pubali.mandal@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3514", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Pubali_Mandal.png",
            Email: "pm_innovations@iittp.ac.in",
            MenuName: "CSRC Office"
        },
        {
            Name: "Ms. K. Jayasree",
            Position: "Senior Executive",
            Email: "jayasreekencham@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/K.Jayasree.jpg",
            MenuName: "CSRC Office"
        },

        // {
        //     Name: "Mr. Shaik Abdul Satthar",
        //     Position: "Junior Executive",
        //     Email: "shaikabdul@iittp.ac.in", // No email provided in the HTML
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/SHAIK ABDUL SATTHAR.jpg",
        //     MenuName: "CSRC Office"
        // },
        {
            Name: "Ms. M. Ramya",
            Position: "Junior Executive",
            Email: "Ramya2099@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3514", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ramya.png",
            MenuName: "CSRC Office"
        },

        // SwayamPrabha Project 

        {
            Name: "Mrs. Avanthi Allaparthi",
            Position: "Senior Project Officer",
            Email: "avanthi@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3681", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Avanthi_Allaparthi.jpg",
            Email: "avanthi@iittp.ac.in",
            MenuName: "SwayamPrabha Project"
        },
        {
            Name: "Mr. Akshai P S",
            Position: "Senior Project Engineer",
            Email: "akshai@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3681", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Akshai.jpg",
            Email: "akshai@iittp.ac.in",
            MenuName: "SwayamPrabha Project"
        },
        {
            Name: "Mr. I Bhanu Prakash",
            Position: "Senior Project Engineer",
            Email: "bhanu7785@iittp.ac.in", // No email provided in the HTML
            phoneno: "0877 250 3681", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bhanu_Prakash.jpg",
            Email: "bhanu7785@iittp.ac.in",
            MenuName: "SwayamPrabha Project"
        },
        {
            Name: "Mr. Sujith Kumar S",
            Position: "Project Associate",
            Email: "sujithsenthilnathan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sujith_Kumar_S_PA.png",
            Email: "sujithsenthilnathan@iittp.ac.in",
            MenuName: "SwayamPrabha Project"
        },

        // {
        //     Name: "Mr. Ajay T",
        //     Position: "Project Associate",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/AJAY_PA.jpg",
        //     Email: "ajaythiyagarajan@iittp.ac.in",
        //     MenuName: "SwayamPrabha Project"
        // }
        // Add more director officers as needed...
    ]);
    const [selectedDirectorOfficers, setSelectedDirectorOfficers] = useState([]); // State to hold director officers related to the selected menu item

    useEffect(() => {
        // Filter DirectorOfficers based on MenuName to get officers related to the selected item (default: 'Director Office')
        const filteredDirectors = DirectorOfficers.filter(officer => officer.MenuName === selectedItem);
        setSelectedDirectorOfficers(filteredDirectors);
    }, [selectedItem, DirectorOfficers]); // Re-run effect when selectedItem or DirectorOfficers change

    const handleItemClick = (itemName) => {
        setSelectedItem(itemName);
    };

    return (
        <div>

            <Header />
            <Breadcrumb title="Home" subtitle="STAFF" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <Container>
                    <Row>

                        {/* Your menu items */}
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <ListGroup.Item as={Link} action to="/chemical-engineering-department" className={`p-3 mb-3`}>
                                <i className="fas fa-chevron-circle-right me-3"></i>
                                Faculty
                            </ListGroup.Item>
                            {/* Your menu items */}
                            <ListGroup className='listgroupmenu mb-3'>
                                <ListGroup.Item as="button" aria-expanded={selectedItem === 'Director Office'} onClick={() => handleItemClick('Director Office')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>Director Office
                                </ListGroup.Item>


                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Registrar Office'} onClick={() => handleItemClick('Registrar Office')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Registrar Office
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Deans Offices'} onClick={() => handleItemClick('Deans Offices')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Deans Offices
                                </ListGroup.Item>
                                </ListGroup>


                                <ListGroup className='listgroupmenu'>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Academic Affairs'} onClick={() => handleItemClick('Academic Affairs')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Academic Affairs
                                </ListGroup.Item>

                                 <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Computer Centre'} onClick={() => handleItemClick('Computer Centre')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Computer Centre
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Competency Development & Outreach'} onClick={() => handleItemClick('Competency Development & Outreach')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Competency Development & Outreach
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Centre of Excellence'} onClick={() => handleItemClick('Centre of Excellence')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Centre of Excellence
                                </ListGroup.Item>
                                
                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Central Instrumentation Facility'} onClick={() => handleItemClick('Central Instrumentation Facility')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Central Instrumentation Facility
                                </ListGroup.Item>

                               

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'CSRC Office'}
                                    onClick={() => handleItemClick('CSRC Office')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    CSRC Office
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Departments'} onClick={() => handleItemClick('Departments')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Departments
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Engineering Unit'} onClick={() => handleItemClick('Engineering Unit')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Engineering Unit
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Establishment'} onClick={() => handleItemClick('Establishment')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Establishment
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Estate Office'} onClick={() => handleItemClick('Estate Office')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Estate Office
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Finance & Accounts'} onClick={() => handleItemClick('Finance & Accounts')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Finance & Accounts
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Global Engagement, Alumni and Corporate Relations'}
                                    onClick={() => handleItemClick('Global Engagement, Alumni and Corporate Relations')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    GAC
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'General Administration'} onClick={() => handleItemClick('General Administration')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    General Administration
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === "Guest House (Visitors Hostel)"}
                                    onClick={() => handleItemClick("Guest House (Visitors Hostel)")}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Guest House (Visitors Hostel)
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === "Guidance & Counselling Unit"}
                                    onClick={() => handleItemClick("Guidance & Counselling Unit")}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Guidance & Counselling Unit
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Health Care'}
                                    onClick={() => handleItemClick('Health Care')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Health Care
                                </ListGroup.Item>
                               

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Hindi Cell'} onClick={() => handleItemClick('Hindi Cell')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Hindi Cell
                                </ListGroup.Item>

                                
                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'HoME Section'}
                                    onClick={() => handleItemClick('HoME Section')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    HoME Section
                                </ListGroup.Item>
                                
                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Laboratories'}
                                    onClick={() => handleItemClick('Laboratories')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Laboratories
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Library'}
                                    onClick={() => handleItemClick('Library')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Library
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'NSS'}
                                    onClick={() => handleItemClick('NSS')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    NSS
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Placement'}
                                    onClick={() => handleItemClick('Placement')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Placement
                                </ListGroup.Item>
                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Planning & Infrastructure'}
                                    onClick={() => handleItemClick('Planning & Infrastructure')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Planning & Infrastructure
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === "Public Relation Office"}
                                    onClick={() => handleItemClick("Public Relation Office")}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Public Relation Office
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Purchase & Stores'} onClick={() => handleItemClick('Purchase & Stores')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Purchase & Stores
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Recruitment'}
                                    onClick={() => handleItemClick('Recruitment')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Recruitment
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Sports'}
                                    onClick={() => handleItemClick('Sports')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Sports
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Student Affairs'}
                                    onClick={() => handleItemClick('Student Affairs')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Student Affairs
                                </ListGroup.Item>

                                

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'SwayamPrabha Project'}
                                    onClick={() => handleItemClick('SwayamPrabha Project')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    SwayamPrabha Project
                                </ListGroup.Item>

                                {/* Add more ListGroup.Items for other menu items */}
                            </ListGroup>
                        </Col>
                        <Col md={9} className='c-right custom-padding-color '>
                            <div className='ms-3'>
                                

                                <h4 className='c-headline mt-2 mb-3'>{selectedItem}</h4>
                                <div className="row">
                                    {selectedDirectorOfficers.map((DirectorOfficer, index) => (
                                        <div key={index} className="col-xl-4 col-md-6">
                                            {/* Display information about each director officer */}
                                            <div className="single-team mb-40" style={{height:'402px',maxHeight:'410px',overflow:'auto'}}>
                                                <div className="team-thumb">
                                                    <div className="brd">
                                                        <a href="#">
                                                            <img src={DirectorOfficer.Image} alt="img" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="team-info">
                                                    <h4>
                                                        <a href={DirectorOfficer.namelink}>{DirectorOfficer.Name}</a>
                                                    </h4>
                                                    <div className="text-dark c-lineheight2">
                                                        <p><i className="fal fa-graduation-cap me-2" />{DirectorOfficer.Position}</p>
                                                        {(DirectorOfficer.Email !== undefined && DirectorOfficer.Email !== "") && (
                                                    
                                                            <p className="text-primary"><i className="fal fa-envelope me-1"></i> 
                                                                <a className='text-primary' href={`mailto:"${DirectorOfficer.Email}`}> {DirectorOfficer.Email}</a></p>
                                                                
                                                        )}
                                                        {(DirectorOfficer.phoneno !== undefined && DirectorOfficer.phoneno !== "") && (
                                                            <p className="text-dark"><i className="fas fa-phone-alt me-1"></i>  {DirectorOfficer.phoneno}</p>
                                                        )}
                                                        {(DirectorOfficer.Department !== undefined && DirectorOfficer.Department !=="") && (
                                                            <p className="text-danger font-weight-bold"><i className="fas fa-building me-1"></i>  {DirectorOfficer.Department}</p>

                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default YourComponent;
